module.exports = __webpack_public_path__ + "img/home.e4eaf48c.svg";